import { render, staticRenderFns } from "./filter-common2.vue?vue&type=template&id=384cd23e&scoped=true&"
import script from "./filter-common2.vue?vue&type=script&lang=js&"
export * from "./filter-common2.vue?vue&type=script&lang=js&"
import style0 from "./filter-common2.vue?vue&type=style&index=0&id=384cd23e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384cd23e",
  null
  
)

export default component.exports